export default "__VITE_ASSET__f230ae98__"